module.exports = __webpack_public_path__ + "img/1524264270.a6645dee.jpg";